import {Model} from '@/models/model';
import {getRelativeTime} from '@/helpers/datetime';
import {v4 as generateUid} from 'uuid';
import {Node} from '@/models/node';
import {reactive} from 'vue';

export const TRIGGER_TYPES = {
    schedule: {
        label: 'Schedule',
        icon: 'update',
    },
    event: {
        label: 'Event',
        icon: 'bolt',
    },
    webhook: {
        label: 'WebHook',
        icon: 'cloud',
    },
};

export let WORKFLOW_NODES_CACHE = reactive({});

function refreshLevel(node, level) {
    node.level = level;
    node.children.forEach(child => refreshLevel(child, level + 1))

    return node;
}

/**
 * @property String id
 * @property String uid
 * @property String type
 */
export class Workflow extends Model {
    bootstrap() {
        Object.defineProperty(this, 'nodesCache', {
            enumerable: false,
            value: reactive({}),
        });
    }

    refresh() {
        refreshLevel(this.tree, 1);
    }

    get_node_by_uid(uid) {
        return this.nodesCache[uid];
    }

    cast_tree(rawTree) {
        return new Node({...rawTree, level: 1, _workflow: this});
    }

    get trigger_type_label() {
        return TRIGGER_TYPES[this.type].label || 'N/A';
    }

    get trigger_type_icon() {
        return TRIGGER_TYPES[this.type].icon || 'settings';
    }

    get time_since_created() {
        return getRelativeTime(this.created_at);
    }

    get time_since_updated() {
        return getRelativeTime(this.updated_at);
    }

    get time_since_last_run() {
        return getRelativeTime(this.last_run_at);
    }

    get time_until_next_run() {
        return getRelativeTime(this.next_run_at);
    }

    duplicate() {
        let json = JSON.stringify(this);
        const regexp = /[\da-f]{8}-([\da-f]{4}-){3}[\da-f]{12}/ig;
        const uids = new Set(json.match(regexp)).values();

        for (const uid of uids) {
            json = json.replaceAll(uid, generateUid());
        }

        const workflow = JSON.parse(json);
        workflow.name = `${workflow.name}`;
        workflow.enabled = false;
        workflow.created_at = workflow.updated_at = (new Date()).toISOString();

        workflow._new = true;

        return new Workflow(workflow);
    }

    copy() {
        return new Workflow({...this});
    }

    isIdenticalTo(workflow) {
        const jsonOfThis = JSON.stringify(this);
        const jsonOfOther = JSON.stringify(workflow);

        return jsonOfOther === jsonOfThis;
    }
}
